<ngx-avatars
        *ngIf="user?.profilePictureUrl else noAvatarTpl"
        class="avatar"
        [style]="customAvatarStyle"
        [size]="size"
        [src]="user.profilePictureUrl">
</ngx-avatars>

<ng-template #noAvatarTpl>
  <img 
    class="avatar" 
    style="border-radius: 50%; object-fit: cover;"
    src="assets/media/vescent/userpic.svg" 
    [width]="size" 
    [height]="size">
</ng-template>

<img 
  class="avatar-custom-icon" 
  *ngIf="icon" 
  src="{{ icon | iconByName }}"
  [width]="size/1.5" 
    [height]="size/1.5"
/>

<!-- [width]="size/1.5" 
  [height]="size/1.5" -->